import { type GiftVoucherDataFragment } from '../../../../api/fragments';

export const colSpan = { lg: 8, md: 12, xs: 24 };

export type SharedDetailProps = {
    voucher: GiftVoucherDataFragment;
};
